import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { cn } from '../../../lib/utils';
// Complete literal class strings (Tailwind JIT): [outline][side].
const GRID = {
    o: {
        s: 'md:grid-cols-[var(--component-outline-width)_minmax(0,1fr)] xl:grid-cols-[var(--component-outline-width)_minmax(0,1fr)_var(--component-editor-side-width)]',
        n: 'md:grid-cols-[var(--component-outline-width)_minmax(0,1fr)]'
    },
    n: {
        s: 'xl:grid-cols-[minmax(0,1fr)_var(--component-editor-side-width)]',
        n: ''
    }
};
// The full-height lock (h-full; the editor iframe then takes the remaining
// height) applies only from the breakpoint where every column sits in ONE grid
// row. Below it the columns stack, and locking the height would split it across
// the stacked rows and squeeze the document to nothing; there the page grows
// instead and the surface keeps its own --component-document-host-min-height.
const FULL_HEIGHT = {
    o: {
        s: 'xl:h-full xl:min-h-0',
        n: 'md:h-full md:min-h-0'
    },
    n: {
        s: 'xl:h-full xl:min-h-0',
        n: 'md:h-full md:min-h-0'
    }
};
/**
 * Full-height editor page: optional outline, a column with header, actions and
 * the document surface (no prose padding or max-width: the hosted editor takes
 * the column), and a collapsible side rail.
 */ export const SpecraEditorWorkspace = /*#__PURE__*/ React.forwardRef(({ actions, children, className, header, outline, side, sideLabel = 'Writing tools', sideOpen = true, ...props }, ref)=>{
    const showSide = Boolean(side) && sideOpen !== false;
    return /*#__PURE__*/ _jsxs("div", {
        className: cn('grid min-h-full grid-cols-1', GRID[outline ? 'o' : 'n'][showSide ? 's' : 'n'], FULL_HEIGHT[outline ? 'o' : 'n'][showSide ? 's' : 'n'], className),
        "data-side": showSide ? 'open' : 'closed',
        ref: ref,
        ...props,
        children: [
            outline ? /*#__PURE__*/ _jsx("div", {
                className: "min-h-0 min-w-0",
                children: outline
            }) : null,
            /*#__PURE__*/ _jsxs("div", {
                className: "flex min-h-0 min-w-0 flex-col gap-[var(--space-3)] px-[var(--space-3)] pb-[var(--space-3)] pt-[var(--space-4)] md:px-[var(--space-4)]",
                children: [
                    header,
                    actions,
                    /*#__PURE__*/ _jsx("div", {
                        className: "flex min-h-0 flex-1 flex-col",
                        children: children
                    })
                ]
            }),
            showSide ? /*#__PURE__*/ _jsx("aside", {
                "aria-label": sideLabel,
                className: cn('min-h-0 min-w-0 overflow-y-auto border-t border-border bg-[color:var(--surface-rail)] xl:border-l xl:border-t-0', outline && 'md:col-span-2 xl:col-span-1'),
                children: side
            }) : null
        ]
    });
});
SpecraEditorWorkspace.displayName = 'SpecraEditorWorkspace';
